import { render, staticRenderFns } from "./WcTablesHeader.vue?vue&type=template&id=79ccfb46&lang=pug&"
import script from "./WcTablesHeader.vue?vue&type=script&lang=js&"
export * from "./WcTablesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports